export function versionToNumber(version: string | undefined): number {
  if (!version) {
    return 0;
  }

  return Number(version.split(".").map(v => v.padStart(4, "0")).join(""));
}

